export interface ObjectSlice {
    objects: [];
    setObjects: (objects: []) => void;
}

export const createObjectSlice = (
    set: (fn: (state: ObjectSlice) => ObjectSlice) => void
): ObjectSlice => ({
    objects: [],
    setObjects: (objects) => set((state) => ({ ...state, objects })),
});
